import API from "./api";

export const getHistory = (params) =>
  API.get("/complete/history", { params });
